import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlEndPoints } from '../config/end-points';

@Injectable({
  providedIn: 'root',
})
export class nurseNeedsDAL {
  constructor(private httpClient: HttpClient) {}

  generateNeeds(TVOCycleId: string, startDate: string, endDate: string): Observable<any[]> {
    return this.httpClient.post<any[]>(urlEndPoints.nurseNeeds + 'generateNeeds', { TVOCycleId, startDate, endDate });
  }

  getNurseFixNeeds(tvo: string, period: string, week?: number): Observable<any[]> {
    return this.httpClient.get<any[]>(
      urlEndPoints.nurseNeeds + 'fixNeeds' + `?tvo=${tvo}&period=${period}&week=${week}`
    );
  }

  updateNurseFixNeeds(tvo: string, needs: any[], period: string, week?: number): Observable<any[]> {
    return this.httpClient.post<any[]>(
      urlEndPoints.nurseNeeds + 'fixNeeds' + `?tvo=${tvo}&period=${period}&week=${week}`,
      needs
    );
  }

  getNurseDailyNeeds(weekDay: string, period: string): Observable<any[]> {
    return this.httpClient.get<any[]>(urlEndPoints.nurseNeeds + 'dailyNeeds/' + weekDay + `?period=${period}`);
  }

  updateNurseDailyNeeds(weekDay: string, needs: any[]): Observable<any[]> {
    return this.httpClient.post<any[]>(urlEndPoints.nurseNeeds + 'dailyNeeds/' + weekDay, needs);
  }

  generateNurseDailyNeeds(
    tvoId: string,
    startDate: string,
    endDate: string,
    creationType: string,
    startingWeekNumber?: number
  ): Observable<any[]> {
    return this.httpClient.post<any[]>(urlEndPoints.nurseNeeds + 'generateNightNeeds', {
      tvoId,
      startDate,
      endDate,
      creationType,
      startingWeekNumber,
    });
  }
}
